import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";

const { P } = typography;
const { ACCENT_PRIMARY_LIGHT } = colors;

export const List = styled.ul``;

export const ItemContainer = styled.li`
  min-height: 40px;
`;

export const ListItem = styled(P)`
  margin-bottom: 16px;

  &::before {
    color: ${ACCENT_PRIMARY_LIGHT};
    content: "•";
    display: inline-block;
    font-size: 26px;
    margin-right: 5px;
    vertical-align: text-bottom;
  }
`;
